import { render, staticRenderFns } from "./PermissionCell.vue?vue&type=template&id=b1f6c454&scoped=true"
import script from "./PermissionCell.vue?vue&type=script&lang=js"
export * from "./PermissionCell.vue?vue&type=script&lang=js"
import style0 from "./PermissionCell.vue?vue&type=style&index=0&id=b1f6c454&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f6c454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f6c454')) {
      api.createRecord('b1f6c454', component.options)
    } else {
      api.reload('b1f6c454', component.options)
    }
    module.hot.accept("./PermissionCell.vue?vue&type=template&id=b1f6c454&scoped=true", function () {
      api.rerender('b1f6c454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/RolePermissions/PermissionCell.vue"
export default component.exports